<template>
  <dl class="tableDefinition">
    <template v-for="(item, i) in items" :key="i">
      <div class="tableDefinition_item" v-if="item.dd !== null">
        <dt>{{ item.dt }}</dt>
        <dd>
          <span>{{ item.dd }}</span
          >{{ item.unit }}
        </dd>
      </div>
    </template>
  </dl>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'

export interface Definition {
  dt: string
  dd: string | number
  unit?: string
}

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<Definition[]>
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.tableDefinition {
  width: 100%;
  display: flex;
  border-bottom: 1px solid var.$color-main;

  &_item {
    flex-basis: 100%;
    text-align: center;
    font-weight: 700;

    @include mixins.mediaMax() {
      font-size: 1rem;
    }

    &:last-child dt {
      border-color: var.$color-main;
    }

    &:last-child dd {
      border-right: 1px solid var.$color-main;
    }
  }

  dt {
    background-color: var.$color-main;
    color: #fff;
    border-right: 1px solid #fff;
    // padding-top: 2px;
    padding-bottom: 1px;
  }

  dd {
    border-left: 1px solid var.$color-main;
    line-height: 1.6;
    padding-bottom: 1px;

    span {
      font-size: 1.8rem;

      @include mixins.media() {
        font-size: 2.2rem;
      }
    }
  }
}
</style>
